import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";


const ReportsStorage = () => {

    const [reports, setReports] = useState([]);
    const [infoMessage, setInfoMessage] = useState("");
    const { jwtToken } = useOutletContext();
    const { userInfo } = useOutletContext();


    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();



    const navigate = useNavigate();

    useEffect(() => {
        if (jwtToken === "") {
            navigate("/");
            return
        }

        // headers for request
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        // options for request
        const requestOptions = {
            method: "GET",
            headers: headers,
            credentials: "include"
        }
        // request to backend
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/reports-storage`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.info) {
                    setInfoMessage(data.message);
                }
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                    return
                } else {
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    setReports(data);
                }
            })
            // in case of error log it
            .catch(err => {
                console.log(err);
            })
    }, [jwtToken, navigate, setAlertClassName, setAlertMessage]);


    const handleOpen = (reportID) => {

        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);


        let method = "GET";

        let requestOptions = {
            method: method,
            headers: headers,
            credentials: "include",
            responseType: 'arraybuffer',
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/report/${reportID}`, requestOptions)
            .then(response => {
                // check if response is in json (error in this case)
                if (response.headers.get("Content-Type").indexOf("application/json") >= 0) {
                    response.json().then(data => {
                        if (data.error) {
                            setAlertClassName("alert-danger"); // show error class
                            setAlertMessage(data.message);
                            return
                        }
                    })
                } else {
                    // check if response is pdf (blob type)
                    response.blob().then(blob => {
                        // Creating new object of PDF file
                        const fileURL = window.URL.createObjectURL(blob);
                        // Setting various property values
                        let alink = document.createElement('a');
                        alink.href = fileURL;
                        alink.download = 'document.pdf';
                        navigate("/pdf", { state: { file: fileURL } });
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })

    }

    const handleDownload = (reportID) => {

        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);


        let method = "GET";

        let requestOptions = {
            method: method,
            headers: headers,
            credentials: "include",
            responseType: 'arraybuffer',
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/report/download/${reportID}`, requestOptions)
            .then(response => {
                // check if response is in json (error in this case)
                if (response.headers.get("Content-Type").indexOf("application/json") >= 0) {
                    response.json().then(data => {
                        if (data.error) {
                            setAlertClassName("alert-danger"); // show error class
                            setAlertMessage(data.message);
                            return
                        }
                    })
                } else { // if response is not json
                    // check if response is pdf (blob type)
                    response.blob().then(blob => {
                        const filename = response.headers.get('Content-Disposition').split('filename=')[1];
                        // Creating new object of PDF file
                        const fileURL = window.URL.createObjectURL(new Blob([blob])); //opens in a new tab
                        // Setting various property values
                        const link = document.createElement('a');
                        link.href = fileURL;
                        link.setAttribute('download', `${filename}`);
                        document.body.appendChild(link);
                        link.click();
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })

    }

    const handleDelete = (reportID) => {

        // ask user if he really wants to delete
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            // if confirmed
            if (result.isConfirmed) {

                // create headers
                const headers = new Headers();
                headers.append("Content-Type", "application/json");
                headers.append("Authorization", "Bearer " + jwtToken);


                let method = "DELETE";

                let requestOptions = {
                    method: method,
                    headers: headers,
                    credentials: "include",
                    responseType: 'arraybuffer',
                }

                // make a request
                fetch(`${process.env.REACT_APP_BACKEND}/api/ar/report/${reportID}`, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            setAlertClassName("alert-danger"); // show error class
                            setAlertMessage(data.message);
                            return
                        } else {
                            setAlertClassName("d-none"); // hide alert if it is
                            setAlertMessage("");
                            // delete report from reports  
                            setReports(reports.filter(item => item.id !== reportID));
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                        }
                    })
                    // in case of error log it
                    .catch(err => {
                        console.log(err);
                    })
            }
        })
    }


    return (
        <div>
            <h2 className="text-center">Reports storage</h2>
            <hr />
            <div><h5>Storage capacity: {reports.length > 0 ? reports.length : "0"} / {userInfo.storageLimit}</h5></div>
            <div>
                <h4 className="text-center mt-5">{infoMessage}</h4>
            </div>
            {reports.length > 0 &&
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Report ID</th>
                            <th>Name</th>
                            <th>Requested at</th>
                            <th>File</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reports.map((m) => (
                            <tr key={m.id}>
                                <td>
                                    {m.id}
                                </td>
                                <td>
                                    {m.name}
                                </td>
                                <td>
                                    {m.requested_at}
                                </td>
                                <td>
                                    <button onClick={() => handleDownload(m.id)} className="btn btn-outline-success ms-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                        </svg>
                                    </button>

                                    <button onClick={() => handleOpen(m.id)} className="btn btn-outline-primary ms-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z" />
                                        </svg>
                                        Open
                                    </button>

                                    <button onClick={() => handleDelete(m.id)} className="btn btn-outline-danger ms-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                        </svg>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </div>
    )
}

export default ReportsStorage;